function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24.494.772l6.928 17.566 17.565 6.928-17.566 6.928-6.927 17.566-6.928-17.566L0 25.266l17.566-6.928L24.494.772z",
  fill: "#00CCBC"
});
function SvgStarBiggest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 50",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/star-biggest-4e9e8590ebe5fad1e0df611502594d59.svg";
export { SvgStarBiggest as ReactComponent };